/* eslint-disable no-console, no-unused-vars, no-param-reassign */

import AES from 'crypto-js/aes';
import CryptoJSCore from 'crypto-js/core';
import stringify from 'json-stringify-safe';
import { createTransform } from 'redux-persist';

import Logger from '../tools/Logger';

const log = Logger.child({ component: 'lib/ReduxEncryptFilter' });

function createEncryptor(secretKey, whitelist = []) {
  return (state, key) => {
    if (whitelist.length === 0 || whitelist.indexOf(key) > -1) {
      if (typeof state !== 'string') {
        state = stringify(state);
      }

      return AES.encrypt(state, secretKey).toString();
    }
    return state;
  };
}

function createDecryptor(secretKey, whitelist = []) {
  return (state, key) => {
    if (typeof state !== 'string') {
      log.error('expected outbound state to be a string');

      return state;
    }

    if (whitelist.length === 0 || whitelist.indexOf(key) > -1) {
      try {
        const bytes = AES.decrypt(state, secretKey);
        const newState = bytes.toString(CryptoJSCore.enc.Utf8);
        return newState;
      } catch (err) {
        log.error(err);
        return null;
      }
    }
    return state;
  };
}

export default function (config) {
  const inbound = createEncryptor(config.secretKey, config.whitelist);
  const outbound = createDecryptor(config.secretKey, config.whitelist);

  return createTransform(inbound, outbound, config);
}
